<template>
  <div id="customerData">
    <!-- Card header -->


    <!-- Card body -->
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form
        class="needs-validation"
        @submit.prevent="handleSubmit(firstFormSubmit)"
      >







        <b-row>

                  <b-col md="6">
                    <h4>Amtliches Kennzeichen </h4>

                    <b-row>
                      <b-col md="4">
                    <base-input 
                    v-model="pl1" 
                    name="Amtl. Kennzeichen" 
                    v-maska="{ mask: 'AAA'}"
                     :rules="{ required: true }"></base-input>

                      </b-col>
                      <b-col md="4">

                     <base-input 
                    v-model="pl2" 
                    name="Amtl. Kennzeichen " 
                    v-maska="{ mask: 'AA'}"
                     :rules="{ required: true }"></base-input>

                      </b-col>
                    
                                         
                      <b-col md="4">

                     <base-input 
                    v-model="pl3" 
                    name="Amtl. Kennzeichen  " 
                    v-maska="{ mask: '####'}"
                     :rules="{ required: true }"></base-input>
                    
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col md="6">
                     <h4>Fahrzeugident-Nr.</h4>
                    <base-input prepend-icon="fas fa-id-card" placeholder="Fahrzeugident-Nr." v-model="offer.vin" name="Fahrzeugident-Nr." :rules="{required: true, min:17, max:17, regex:/[a-zA-Z0-9]+/ }"></base-input>
                  </b-col>

        </b-row>

        <b-row>

                  <!-- b-col md="6">
                    <h4>Erstzulassung</h4>

                    {{ offer.car_first_registration }}
                                <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.car_first_registration"
              name="Erstzulassung"
              rules="required"
              type="date"
              placeholder="DD.MM.YYYY"
            >
            </base-input>




                  </b-col -->

                  <b-col md="6" v-if="offer.is_car">
                     <h4>Akt. Tachostand</h4>
                    <base-input 
                    prepend-icon="fas fa-mobile" 
                    placeholder="Akt. Tachostand" 
                    v-model="offer.current_mileage" 
                    name="Akt. Tachostand" 
                    :rules="{ required: true, regex:/[0-9]+/ }"></base-input>
                  </b-col>

        </b-row>












      </form>
    </validation-observer>
  </div>
</template>

<script>


import { extend } from "vee-validate";
import { required, min } from "vee-validate/dist/rules";
import { configure } from 'vee-validate';
import { localize } from 'vee-validate';
import de from 'vee-validate/dist/locale/de.json';





import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "car",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    "v-select": vSelect,
  },
  data() {
    return {

      loading: false,
      pl1: '',
      pl2: '',
      pl3: '',
      tmpplate: [],

    };
  },
  methods: {
    splitPlate(){
      this.theplate = this.offer.plate.split(/ |-/);
      this.pl1 = this.theplate[0];
      this.pl2 = this.theplate[1] || '';
      this.pl3 = this.theplate[2] || '';
    }
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
      plate: (state) => state.offer.plate,
    }),
  },
  watch: {
    pl1(){
      this.offer.plate = this.pl1 + " " + this.pl2 + "-" + this.pl3;
    },
    pl2(){
      this.offer.plate = this.pl1 + " " + this.pl2 + "-" + this.pl3;
    },
    pl3(){
      this.offer.plate = this.pl1 + " " + this.pl2 + "-" + this.pl3;
    },
    plate(){
     this.splitPlate();
    },
},

  mounted() {
    this.splitPlate();
  },
};
</script>
<style>
</style>